<template>
  <div>
    <FieldSingleText
      v-if="type === 'FieldSingleText'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      v-on:addedSingleTextContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldSingleText>
    <FieldImageInput
      v-if="type === 'FieldImageInput'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired === 'true'"
      v-on:addedFileinputContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldImageInput>
    <FieldTextArea
      v-if="type === 'FieldTextArea'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      v-on:addedTextAreaInputContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldTextArea>
    <Field150Word
      v-if="type === 'Field150Word'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      v-on:added150WordContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </Field150Word>
    <FieldLabel
      v-if="type === 'FieldLabel'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      v-on:added150WordContent="populateFieldInput($event)"
      :display-field="displayField"
      :options="options"
      :error-class="errorClass">
    </FieldLabel>
    <FieldLink
      v-if="type === 'FieldLink'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      v-on:added150WordContent="populateFieldInput($event)"
      :display-field="displayField"
      :options="options"
      :error-class="errorClass">
    </FieldLink>
    <FieldYesNo150Word
      v-if="type === 'FieldYesNo150Word'"
      :label="description"
      :label-secondary="secondaryDescription"
      :label-lvl2="descriptionLvlTwo"
      :label-secondary-lvl2="secondaryDescriptionLvlTwo"
      :is-required="isRequired"
      v-on:addedYesNoContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldYesNo150Word>
    <FieldRadio
      v-if="type === 'FieldRadio'"
      :label="description"
      :label-secondary="secondaryDescription"
      :label-lvl2="descriptionLvlTwo"
      :label-secondary-lvl2="secondaryDescriptionLvlTwo"
      :is-required="isRequired"
      v-on:addedYesNoContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldRadio>
    <FieldFileInput
      v-if="type === 'FieldFileInput'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired === 'true'"
      v-on:addedFileinputContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldFileInput>
    <FieldCheckBoxesCharacteristics
      v-if="type === 'FieldCheckBoxesCharacteristics'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldCheckBoxesCharacteristics>
    <FieldCheckBoxes
      v-if="type === 'FieldCheckBoxes'"
      :label="description"
      :label-secondary="secondaryDescription"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :display-field="displayField"
      :error-class="errorClass">
    </FieldCheckBoxes>
    <FieldCheckBoxesBehaviours
      v-if="type === 'FieldCheckBoxesBehaviours'"
      :label-secondary="secondaryDescription"
      :label="description"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      :display-field="displayField"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :error-class="errorClass">
    </FieldCheckBoxesBehaviours>
    <FieldSelectGroup
      v-if="type === 'FieldSelectGroup'"
      :label-secondary="secondaryDescription"
      :label="description"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      :display-field="displayField"
      :categoryNomination="categoryNomination"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :error-class="errorClass">
    </FieldSelectGroup>    
    <FieldHigh5Cards
      v-if="type === 'FieldHigh5Cards'"
      :label-secondary="secondaryDescription"
      :label="description"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      :display-field="displayField"
      v-on:selectedBehaviour="populateFieldInput($event)"
      :error-class="errorClass">
    </FieldHigh5Cards>
    <FieldSelect
      v-if="type === 'FieldSelect'"
      :label-secondary="secondaryDescription"
      :label="description"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      :display-field="displayField"
      :categoryNomination="categoryNomination"
      :options="options"
      :selected="selected"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :error-class="errorClass">
    </FieldSelect>
    <FieldDowngradeRejection
      v-if="type === 'DowngradeRejectionReason'"
      :label-secondary="secondaryDescription"
      :label="description"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      :display-field="displayField"
      :categoryNomination="categoryNomination"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :error-class="errorClass">
    </FieldDowngradeRejection>
    <FieldMCGTemplate
      v-if="type === 'FieldMCGTemplate'"
      :label-secondary="secondaryDescription"
      :label="description"
      :is-required="isRequired"
      :checkbox-labels="checkboxLabels"
      :display-field="displayField"
      :categoryNomination="categoryNomination"
      v-on:addedCheckBoxesContent="populateFieldInput($event)"
      :options="options"
      :nomineeLabels="nomineeLabels"
      :error-class="errorClass">
    </FieldMCGTemplate>    
  </div>
</template>

<script>
import Field150Word from '@/components/Field150Word'
import FieldLabel from '@/components/FieldLabel'
import FieldLink from '@/components/FieldLink'
import FieldFileInput from '@/components/FieldFileInput'
import FieldImageInput from '@/components/FieldImageInput'
import FieldCheckBoxesCharacteristics from '@/components/FieldCheckBoxesCharacteristics'
import FieldCheckBoxesBehaviours from '@/components/FieldCheckBoxesBehaviours'
import FieldCheckBoxes from '@/components/FieldCheckBoxes'
import FieldSingleText from '@/components/FieldSingleText'
import FieldTextArea from '@/components/FieldTextArea'
import FieldYesNo150Word from '@/components/FieldYesNo150Word'
import FieldRadio from '@/components/FieldRadio'
import FieldHigh5Cards from '@/components/FieldHigh5Cards'
import FieldDowngradeRejection from '@/components/FieldDowngradeRejection'
import FieldSelect from '@/components/FieldSelect'
import FieldSelectGroup from '@/components/FieldSelectGroup'
import FieldMCGTemplate from '@/components/FieldMCGTemplateCheck'

export default {
  components: {
    Field150Word,
    FieldLabel,
    FieldLink,
    FieldTextArea,
    FieldFileInput,
    FieldImageInput,
    FieldCheckBoxesCharacteristics,
    FieldCheckBoxes,
    FieldSingleText,
    FieldYesNo150Word,
    FieldHigh5Cards,
    FieldCheckBoxesBehaviours,
    FieldDowngradeRejection,
    FieldSelect,
    FieldSelectGroup,
    FieldRadio,
    FieldMCGTemplate
  },
  props: [
    'type',
    'description',
    'secondaryDescription',
    'descriptionLvlTwo',
    'secondaryDescriptionLvlTwo',
    'isRequired',
    'checkboxLabels',
    'displayField',
    'errorClass',
    'dataImages',
    'categoryNomination',
    'options',
    'selected',
    'defaultText',
    'labelContent',
    'nomineeLabels'
  ],
  methods: {
    populateFieldInput: function (content) {
      this.$emit('updatedFieldContent', content)
    }
  }
}
</script>

<style lang="less">
  label {
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/NominationField.vue